




























import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { Document } from '@/model/document2/document';

import * as def from "@/definitions";

import DropdownList from "@/commonComponents/dropdownList/dropdownList.vue";

// ボタン
import ArrowDown from "../resources/arrowDown.vue";
import ArrowRight from "../resources/arrowRight.vue";

@Component({
  components: {
    DropdownList,
    ArrowDown,
    ArrowRight
  }
})
export default class TableRow extends Vue {

    @Prop() private document!: Document;

    //-----開閉のアニメーション-----//
    openStatus = {
        opend: true
    };

    tableRowContentsOpenAnimate = false;
    tableRowContentsCloseAnimate = false;

    open() {
        if (this.openStatus.opend) {
            this.tableRowContentsCloseAnimate = true;
            setTimeout(() => {
                this.tableRowContentsCloseAnimate = false;
                this.tableRowContentsOpenAnimate = false;
                this.openStatus.opend = false;
            }, 200);
        } else {
            this.openStatus.opend = true;
            this.tableRowContentsOpenAnimate = true;
            setTimeout(() => {
                this.tableRowContentsOpenAnimate = false;
            }, 250);
        }
    }
    //-----開閉のアニメーション-----//

    private onClickOrder(isAscending : boolean)
    {
        this.$emit("doCommand", "orderRow", { isAscending : isAscending });
    }

    //-----configcolor-----//
    private get userConfigColor(){
        return this.$store.getters.userConfigColors.buttonColorCode;
    }
    private get userConfigUnderLineColor(){
        var style = {
            backgroundColor : this.userConfigColor
        };
        return style;
    }
    private get userConfigFontColor(){
        var style = {
            color : this.userConfigColor
        };
        return style;
    }
    private get userConfigTextAColorStyle(){
        var style = {
            color : this.$store.getters.userConfigColors.textAColor
        };
        return style;
    }

    private get userConfigTextBColorStyle(){
        var style = {
            color : this.$store.getters.userConfigColors.textBColor
        };
        return style; 
    }
    //-----configcolor-----//
}
